import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

import { JssNodeAbstract, JssAbstFlags } from './jss-tree-abstract';
import { JssTreeNodeType, FormLayout } from './jss-types';
import { JssTreeObject } from './jss-tree-object';

export class JssTreeLayout extends JssNodeAbstract {

   constructor(
      nodeName: string
   ) {
      super(nodeName, 'LAYOUT');
   }

   // add child
   public addChild(child: JssNodeAbstract): JssNodeAbstract {
      if (!child) {
         console.warn('Passed param: miss child');
      }
      this._children.push(child);
      child.parent = this;
      return child;
   }

   public findDirectChildByName(nodeName: string) {
      for (const item of this._children) {
         if (item.nodeName === nodeName) {
            return item;
         }
      }
      return null;
   }

   // for all objects/layouts
   public reveFindLocalPathRootNode(): JssTreeObject {
      // pass through
      for (const item of this._children) {
         if (item.nodeType === 'OBJECT') {
            const node = (item as JssTreeObject).reveFindLocalPathRootNode();
            if (node) {return node; }
         } else if (item.nodeType === 'LAYOUT') {
            const node = (item as JssTreeLayout).reveFindLocalPathRootNode();
            if (node) {return node; }
         }
      }
      return null;
   }

   public recveDumpJssTree(indent: string) {
      let s = indent + this._nodeName + '<' + this._nodeType + '>=';
      if (this.hasTitle()) {
         s += 'Title:' + this._title;
      }
      if (this.isRequired()) {
         s += ',<Requ>';
      }
      console.log(s);

      // children
      for (const item of this._children) {
         item.recveDumpJssTree(indent + '  ');
      }
   }

   public reveFindChildByPath(pathFragments: string[]): JssNodeAbstract {
      // pass request to next level
      return this.reveFindChildByPath(pathFragments);
   }

   public recveGenFormTree(form: FormGroup) {
      for (const item of this._children) {
         item.recveGenFormTree(form);
      }
   }

   public recveCreateDataObject(data: any) {
       // pass through
      for (const item of this._children) {
         item.recveCreateDataObject(data);
      }
   }

   public recveEvalSchema(
      dump_output: boolean
   ) {
      // traverse children to check if 'required' ist defined in schema
      for (const item of this._children) {
         item.recveEvalSchema(dump_output);
      }
   }

   // traverse children and set 'required' flag (if object ist set to 'required')
   public reveSetAllChildrenRequiredFlag(): void {
      // all children
      for (const item of this._children) {
         // layout
         if (item.nodeType === 'LAYOUT') {
            (item as JssTreeLayout).reveSetAllChildrenRequiredFlag();
         } else {
            // all but object
            item.required = true;
         }
      }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-tree-layout.ts